import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { SimCardOutlined } from "@material-ui/icons";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useGetReplacementCost } from "./hook/useGetReplacementCost";
import { ReplacementSimAddress } from "./ReplacementSimAddress";

interface IParams {
    closeForm(): void;
    displayModal(): void;
    getSimReplacePending: () => void;
}

export const ReplacementSimForm = (props: IParams) => {
    const { closeForm, displayModal, getSimReplacePending } = props;
    const { t } = useTranslation(["sim", "common"]);
    const { getReplacementCostState, replacementCostDetails, getReplacementCostDetails } = useGetReplacementCost();

    const getReplacementAmount = (replacementCostAmount: number) => t("common:price", { price: replacementCostAmount });

    return (
        <HandleErrorAndLoading
            error={getReplacementCostState.error}
            isLoading={getReplacementCostState.isLoading}
            retryFetch={getReplacementCostDetails}
        >
            {replacementCostDetails && (
                <Fragment>
                    <Grid className="replacementSim__text" container justify="center" alignItems="center">
                        <Grid item>
                            <SimCardOutlined color="primary" style={{ fontSize: "41px", marginRight: "8px" }} />
                        </Grid>
                        <Grid item>
                            <Typography color="primary" variant="h5">
                                <strong>{t("sim:simReplacement")}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid className="replacementSim__text" container justify="center">
                        <Grid item>
                            <Typography align="center" color="primary" variant="h4">
                                {`${t("sim:cost")}: ${getReplacementAmount(replacementCostDetails.amount)}`}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid className="replacementSim__text" container justify="center">
                        <Grid item>
                            <Typography align="center" color="secondary">
                                {t("sim:chargeNextInvoice")}
                            </Typography>
                        </Grid>
                    </Grid>
                    <ReplacementSimAddress
                        closeForm={closeForm}
                        displaySnackbar={displayModal}
                        getSimReplacePending={getSimReplacePending}
                    />
                </Fragment>
            )}
        </HandleErrorAndLoading>
    );
};
